import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal, Eyebrow } from "@/components/Reveal";
import { PRICING_TEASER } from "@/data/pricing";

const PricingTeaser = () => (
    <section data-testid="pricing-teaser" className="border-t border-white/10">
        <div className="mx-auto max-w-7xl px-6 py-24 md:px-10 md:py-32">
            <Reveal className="flex flex-wrap items-end justify-between gap-8">
                <div>
                    <Eyebrow>Pricing</Eyebrow>
                    <h2 className="mt-6 max-w-xl font-display font-black tracking-tighter text-4xl sm:text-5xl leading-[1.05]">
                        Clear tiers, <span className="font-editorial italic font-light text-gold">clear terms.</span>
                    </h2>
                </div>
                <Link
                    to="/pricing"
                    data-testid="pricing-teaser-link"
                    className="inline-flex items-center gap-2 rounded-full border border-gold/40 px-7 py-3 text-sm text-gold transition-colors duration-300 hover:bg-gold hover:text-black"
                >
                    Compare all plans <ArrowUpRight size={15} />
                </Link>
            </Reveal>
            <div className="mt-14 grid gap-px border border-white/10 bg-white/10 md:grid-cols-3">
                {PRICING_TEASER.map((t, i) => (
                    <Link
                        key={t.id}
                        to={`/pricing#${t.id}`}
                        data-testid={`pricing-teaser-${t.id}`}
                        className="group bg-obsidian p-8 md:p-10 transition-colors duration-300 hover:bg-coal/60"
                    >
                        <span className="font-mono text-[11px] uppercase tracking-[0.25em] text-zinc-500">
                            0{i + 1}
                        </span>
                        <h3 className="mt-5 font-display text-xl font-extrabold tracking-tight">{t.name}</h3>
                        <div className="mt-6 flex items-baseline gap-2">
                            <span className="font-mono text-xs text-zinc-500">from</span>
                            <span className="font-mono text-3xl font-medium tracking-tight text-gold">${t.from}</span>
                            <span className="font-mono text-xs uppercase tracking-[0.15em] text-zinc-500">{t.suffix}</span>
                        </div>
                        <span className="mt-8 inline-flex items-center gap-2 text-sm text-zinc-400 transition-colors duration-300 group-hover:text-gold">
                            View tiers <ArrowUpRight size={14} />
                        </span>
                    </Link>
                ))}
            </div>
        </div>
    </section>
);

export default PricingTeaser;
